/* eslint-disable react/no-array-index-key */
import { FC, useEffect, useState } from 'react';

import ResourceConversionPanel from 'organisms/Cards/ResourceConversionPanel';
import { ResourceConversionPanelConfigProps } from 'organisms/Cards/ResourceConversionPanel/config';

import NoResults from 'layout/Listing/components/NoResults';
import ResourceCard from 'layout/Listing/components/ResourceCard';

import { hasArrayValues } from 'utils/array/arrays';

interface StandardFeedProps {
  posts: { data: BlogResource | EventResource | CustomerStoryResource }[];
  newsletterCard?: BuilderReference<ResourceConversionPanelConfigProps>;
}

const StandardFeed: FC<StandardFeedProps> = ({ posts, newsletterCard }) => {
  const [showNewsletter, setShowNewsletter] = useState(false);

  useEffect(() => {
    // Small delay to prevent race condition between Builder references
    // (avoids form data being overwritten when multiple components use the same hook)
    const timer = setTimeout(() => {
      setShowNewsletter(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {hasArrayValues(posts) ? (
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 ">
          {posts.map(
            (post, index) =>
              post.data && <ResourceCard key={`${post.data.title}-${index}`} {...post.data} priority={index === 0} />,
          )}
          {showNewsletter && newsletterCard && posts.length > 4 && (
            <ResourceConversionPanel
              className="col-span-full row-start-5 sm:row-start-3"
              {...newsletterCard}
              theme="green"
            />
          )}
        </div>
      ) : (
        <NoResults />
      )}
    </>
  );
};

export default StandardFeed;
